import { Component, Input } from '@angular/core';
import * as moment from 'moment';
import { ConfigService } from 'src/app/core/service/config.service';

@Component({
  selector: 'app-auction-item-card',
  templateUrl: './auction-item-card.component.html',
  styles: [],
})
export class AuctionItemCardComponent {
  @Input() AuctionData: any;
  @Input() ShowBageIcons: boolean = false;
  @Input() SearchPage: boolean = false;

  countdown: number = 60 * 5; // 5 minutes
  timer: any;

  initDate: any = new Date();
  endDate: any = new Date();
  authUserIsAdmin: any;
  constructor(public _config: ConfigService) {
    this.authUserIsAdmin =
      _config.getAuthUserInfo()?.user?.role_code == 'Admin';
  }
  ngOnInit(): void {
    this.endDate.setMinutes(this.initDate.getMinutes() + 120);
    this.timer = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(this.timer);
      }
    }, 1000);
  }

  changeTime(value: any) {
    // console.log("On Change Time", value);
    return moment(value).format();
  }

  OnNavigate(auction_id: string) {
    let URL = '';
    let ID = auction_id;
    let User = this._config.getAuthUserInfo();
    if (User?.user) {
      if (User?.user?.role_code == 'General' && this.AuctionData?.is_multi_auction) {
        URL = 'mulit-auction/';
        ID = this.AuctionData?.room ? this.AuctionData?.room?.id : this.AuctionData?.room_id
      } else if (User?.user?.role_code == 'General' && !this.AuctionData?.is_multi_auction) {
        URL = 'auction/';
        ID = this.AuctionData.id;
      } else if (User?.user?.role_code != 'General' && this.AuctionData?.is_multi_auction) {
        URL = '/rooms/Multi/detailes/';
        ID = this.AuctionData?.room ? this.AuctionData?.room?.id : this.AuctionData?.room_id
      } else if (User?.user?.role_code != 'General' && !this.AuctionData?.is_multi_auction) {
        URL = '/rooms/auction/';
        ID = this.AuctionData?.id;
      }
    } else {
      if (this.AuctionData?.is_multi_auction) {
        URL = 'mulit-auction/';
        ID = this.AuctionData?.room ? this.AuctionData?.room?.id : this.AuctionData?.room_id
      } else {
        URL = 'auction-details/';
      }
    }

    this._config._router.navigate([URL, ID]);

    // const url = this._config._router.createUrlTree([URL, auction_id])
    // window.open(url.toString(), '_blank')
  }
}
